export const PRODUCT_IMPORT = 'PRODUCT_IMPORT'
export const PRODUCT_IMPORT_FULFILLED = 'PRODUCT_IMPORT_FULFILLED'
export const RESET_PRODUCT_IMPORT = 'RESET_PRODUCT_IMPORT'

export const SET_OPEN_IMPORT_WINDOW = 'SET_OPEN_IMPORT_WINDOW'
